import { Accordion, AccordionItemHeading, AccordionItemState } from "react-accessible-accordion";
import { INLINES, Text } from "@contentful/rich-text-types";
import parse from 'html-react-parser';
import type { Options } from "@contentful/rich-text-react-renderer";

import * as Link from '../Link';
import RichText from '../RichText';

import { Answer, FAQsListItem, Question } from './styles';

const bodyOptions: Options = {
  renderNode: {
    [INLINES.HYPERLINK]: (node, children) => (
      <Link.Blue href={node.data.uri} fontSize="inherit">
        {children}
      </Link.Blue>
    ),
    [INLINES.ENTRY_HYPERLINK]: (entry) => (
      <Link.Blue
        href={entry.data.target.asset.localImage.publicURL}
        staticResource
      >
        {(entry.content[0] as Text).value}
      </Link.Blue>
    ),
  },
};

interface FAQAccordionProps {
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  combinatorSectionItems: any[];
  faqAnchor?: string;
  onChange?: (args: string[]) => void;
}

const FAQAccordion = ({
  combinatorSectionItems,
  faqAnchor,
  onChange = () => {},
}: FAQAccordionProps) => (
  <Accordion
    allowZeroExpanded
    key={faqAnchor}
    preExpanded={faqAnchor ? [faqAnchor] : undefined}
    onChange={onChange}
  >
    {combinatorSectionItems.map(({ answerRTF, question, anchorName }) => (
      <FAQsListItem id={anchorName} uuid={anchorName} key={question.question}>
        <AccordionItemHeading>
          <AccordionItemState>
            {({ expanded }) => (
              <Question expanded={expanded?.toString()}>
                {parse(question.question)}
              </Question>
            )}
          </AccordionItemState>
        </AccordionItemHeading>
        <Answer>
          <RichText document={answerRTF} options={bodyOptions} />
        </Answer>
      </FAQsListItem>
    ))}
  </Accordion>
);

export default FAQAccordion;
